import { Component, OnInit, Input, Output, EventEmitter, Optional, Inject, OnChanges } from '@angular/core';
import {
  CheckstatusChangeObj,
  Reason,
  DataIds,
  StatusChangeActivity,
  ISaveStatusChangeActivity,
} from 'src/app/shared/models/activity-dashboard-model';
import { ActivityService } from 'src/app/core/services/activity.service';
import { FileService } from '../../../core/services/file.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormControl } from '../../../../../node_modules/@angular/forms';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';

@Component({
  selector: 'app-coupled-statuschange-activity',
  templateUrl: './coupled-statuschange-activity.component.html',
  styleUrls: ['./coupled-statuschange-activity.component.scss'],
  standalone: false,
})
export class CoupledStatuschangeActivityComponent implements OnInit, OnChanges {
  launchPad = {
    candidate: [
      {
        candidateId: '',
        doj: '',
        offerStatus: '',
        posLoc: '',
        activityId: null,
      },
    ],
  };

  indentObject = {
    appCode: '',
    aprMail: 0,
    candidateID: '',
    country: '',
    empNo: '',
    ijpflag: 1,
    indentID: '',
    jobLevel: '',
    lastModifiedBy: '',
    pucode: '',
    roleCode: '',
  };

  updateOffer = {
    dojs: '',
    puIds: '',
    postingLocations: '',
  };

  unBlockIndentObj = {
    appCode: 'InTAP',
    candidateID: '',
    dateofJoining: '',
    empNo: '',
    empSourceCode: 'InTAP',
    indentID: '',
    lastModifiedBy: '',
    stageCode: 'REOPEN',
  };

  // file upload
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  toggleBtn: boolean = false;
  multiple = 'multipleSelect';
  fileDemoData: any;
  single = 'single';
  editId: any;
  fileData: any;
  deletedFile: any;
  companyHiringType: any; //= 1;

  public isCollapsed: boolean = false;
  //time
  public timeModifiedOn: string;

  @Input() checkStatusChangeObj: CheckstatusChangeObj;
  @Input() coupledcheckStatusChangeObj: CheckstatusChangeObj;

  value: boolean;
  val: boolean;
  ids: DataIds;
  remarksField: string;
  reasonDescription: any;
  deleteMsg: string;
  reason: string;
  reasonobj: Reason;

  isDeleteDisable: boolean = true;
  @Input() candidateApplicationIds: number[];
  @Input() ifCoupled: boolean;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();
  @Output() coupledformValid: EventEmitter<boolean> = new EventEmitter();
  @Input() candidateObj: any; //offer change
  reasondesc: string;
  editactivity: any = false;
  reasonid: number;
  reasonCtrl = new FormControl();
  userloggedin: any;
  loginUserName: any;
  //@Input() dialogRef: MatDialogRef<ActivityDialogComponent>;
  constructor(
    private activityService: ActivityService,
    private fileService: FileService,
    public confirmDialog: MatDialog,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.checkStatusChangeObj = data.checkStatusChangeObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
    }
  }

  rejectionReasons: any;
  selectedValue: string;
  selectedValue2: string;
  toField: any;
  notes: string;
  reasonId: any;
  saveMsg: string;
  notes2: string;
  reasonId2: any;

  resObj: any;
  empAttributes: any;
  empNo: any;
  SFOData: any;
  disableSFO: boolean;
  recallActivity: boolean;

  ngOnInit() {
    //this.getActivity();

    //offer changes starts

    this.empAttributes = localStorage.getItem('loggedInUser');
    console.log(this.empAttributes);
    this.empNo = JSON.parse(this.empAttributes).attributes.EmpNo[0];

    //offer changes end
    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');

    //offer changes
    if (this.candidateObj) {
      this.activityService.getCandidateOfferUpdate(this.candidateObj[0].applicationId).subscribe((dataFetched) => {
        console.log('Data', dataFetched);
        this.resObj = dataFetched;
      });
    }

    //offer changes
    console.log('coupled paasas', this.coupledcheckStatusChangeObj);

    console.log('this.check statiyst obj', this.checkStatusChangeObj);
    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    this.loginUserName = this.userloggedin.username;
    console.log(this.loginUserName);

    // this.editId = { objectId: this.checkStatusChangeObj.applicationId, objectType: 'AP' };
    console.log('in ngOninit', this.notes);
    let activityId;
    if (this.checkStatusChangeObj !== undefined) {
      activityId = this.checkStatusChangeObj.activityId;
      console.log('activity id couple status vhan---', activityId);
    }

    if (activityId) {
      this.activityService.getActivityReasons(activityId).subscribe((data) => {
        //console.log(data);
        this.rejectionReasons = data;
        console.log('rejection reason', this.rejectionReasons);
      });
    }

    // this.activityService.getReasons().subscribe(data => {
    //   this.rejectionReasons = data;
    // })
    console.log(this.checkStatusChangeObj);
    if (this.editactivity) {
      console.log(this.checkStatusChangeObj);
      this.editId = {
        objectId: this.checkStatusChangeObj.applicationId,
        objectType: 'AP',
        activityId: this.checkStatusChangeObj.activityId,
      };
      console.log(this.checkStatusChangeObj);
      this.getActivity(this.checkStatusChangeObj);
    }

    //offer changes
    // this.showMoreLess();
    if (this.candidateObj && this.checkStatusChangeObj.activityId == 600301) {
      this.activityService
        .getSFO(this.candidateObj[0].candidateId, this.companyHiringType, this.candidateObj[0].applicationId)
        .subscribe((sfodata) => {
          console.log('sfo data', sfodata);
          this.SFOData = sfodata;
          if (this.SFOData != 'Success') {
            this.disableSFO = true;
            const dangerdata = {
              msg: sfodata,
              isSuccess: false,
            };
            this.activityService.openSnackBar(dangerdata, 'danger-snack');
          }
        });
    }

    if (this.checkStatusChangeObj.activityId == 600306) {
      this.recallActivity = true;
    }
  }

  //offer changes
  createLaunchPadObject() {
    this.launchPad.candidate[0].candidateId = this.candidateObj[0].candidateId;
    this.launchPad.candidate[0].doj = this.resObj.joining_date;
    this.launchPad.candidate[0].offerStatus = this.checkStatusChangeObj.activityName;
    this.launchPad.candidate[0].posLoc = this.resObj.location;
    this.launchPad.candidate[0].activityId = this.checkStatusChangeObj.activityId;
    console.log('launchpad', this.launchPad);
  }

  createIndentObject() {
    this.indentObject.appCode = 'InTAP';
    this.indentObject.empNo = this.empNo;
    this.indentObject.ijpflag = 0;
    this.indentObject.indentID = this.resObj.indentId;
    this.indentObject.jobLevel = this.resObj.jobLevel;
    this.indentObject.lastModifiedBy = this.resObj.lastModifiedBy;
    this.indentObject.pucode = this.resObj.puCode;
    this.indentObject.roleCode = this.resObj.roleCode;
    this.indentObject.aprMail = 0;
    this.indentObject.candidateID = this.candidateObj[0].candidateId;
    this.indentObject.country = this.resObj.countryCode;

    console.log('ONDENT OBJECT', this.indentObject);
  }
  updateOfferData() {
    this.updateOffer.dojs = this.resObj.dojs;
    this.updateOffer.postingLocations = this.resObj.postingLocations;
    this.updateOffer.puIds = this.resObj.puIds;
    console.log('update Offer detail', this.updateOffer);
  }
  createNonIndentObject() {
    this.unBlockIndentObj.appCode = 'InTAP';
    this.unBlockIndentObj.empNo = this.empNo;
    this.unBlockIndentObj.empSourceCode = 'InTAP';
    this.unBlockIndentObj.indentID = this.resObj.indentId;
    this.unBlockIndentObj.lastModifiedBy = this.resObj.lastModifiedBy;
    this.unBlockIndentObj.stageCode = 'REOPEN';
    this.unBlockIndentObj.candidateID = this.candidateObj[0].candidateId;
    this.unBlockIndentObj.dateofJoining = this.resObj.joining_date;

    console.log('unblockindent data', this.unBlockIndentObj);
  }

  //offer changes
  testformValid(flag) {
    console.log('couple form valid');
    this.coupledformValid.emit(flag);
  }

  ngOnChanges() {
    console.log('in ngonchanges');
    this.reasonId = null;
    this.notes = '';
  }
  // expand/collapse action
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }

  send() {
    this.ids = this.activityService.getDataIds();
    if (this.editactivity) {
      const obj: StatusChangeActivity = {
        applicationIds: this.checkStatusChangeObj.applicationId,
        processID: this.checkStatusChangeObj.processId,
        activityID: this.checkStatusChangeObj.activityId,
        statusId: this.checkStatusChangeObj.statusId,
        reasonId: Number(this.reasonId),
        notes: this.notes,
        createdOn: this.checkStatusChangeObj.createdOn,
        createdBy: this.checkStatusChangeObj.createdBy,
      };
      this.editStatusChangeActivity(obj);
    } else {
      console.log('obj passed', this.checkStatusChangeObj);
      let objS: ISaveStatusChangeActivity;
      console.log('checkstatustobhj', this.checkStatusChangeObj);
      console.log('couplde', this.coupledcheckStatusChangeObj);
      if (this.checkStatusChangeObj !== undefined) {
        console.log('inside check statuts');
        objS = {
          applicationIds: this.candidateApplicationIds,
          processID: this.checkStatusChangeObj.processId,
          activityID: this.checkStatusChangeObj.activityId,
          statusId: this.checkStatusChangeObj.statusId,
          reasonId: Number(this.reasonId),
          notes: this.notes,
        };
      }
      console.log(this.checkStatusChangeObj.statusChangeActivity);
      this.saveStatusChangeActivity(objS);
    }
    this.showMoreLess();
    // this.refreshcandiates.emit("true");
  }

  saveStatusChangeActivity(obj: ISaveStatusChangeActivity) {
    console.log('inside save');

    console.log(obj);
    if (this.reasonId != null) {
      console.log('inside if');
      //offer changes starts

      switch (this.checkStatusChangeObj.activityId as any) {
        case '600304':
          this.createIndentObject();
          this.activityService.indentBlock(this.indentObject).subscribe((dataFetch) => {
            console.log('DATAFETCH INDENT', dataFetch);
          });
          //  this.updateOfferData()
          //  this.activityService.updateOfferDetails(this.candidateObj[0].applicationId, this.updateOffer).subscribe(response => {
          //    console.log("update Offer detail",response)
          //  })
          this.createLaunchPadObject();
          this.activityService.updateLaunchPad(this.launchPad).subscribe((responseLP) => {
            console.log('launchpad', responseLP);
          });
          this.activityService
            .blockBudget(this.candidateObj[0].applicationId, this.checkStatusChangeObj.activityId)
            .subscribe((responseBB) => {
              console.log('blockbudget', responseBB);
            });
          break;
        case '600305':
          this.createNonIndentObject();
          this.activityService
            .unblockIndent(this.candidateObj[0].applicationId, this.unBlockIndentObj)
            .subscribe((indendata) => {
              console.log('unblockIndentreject', indendata);
            });

          //  this.updateOfferData()
          //  this.activityService.updateOfferDetails(this.candidateObj[0].applicationId, this.updateOffer).subscribe(response => {
          //    console.log("update Offer detail on reject",response)
          //  })
          this.createLaunchPadObject();
          this.activityService.updateLaunchPad(this.launchPad).subscribe((responseLP) => {
            console.log('launchpadreject', responseLP);
          });

          this.activityService
            .unBlockBudget(this.candidateObj[0].applicationId, this.checkStatusChangeObj.activityId)
            .subscribe((unblockdata) => {
              console.log('unBlockBudget rejct', unblockdata);
            });
          break;

        case '600306':
          if (this.checkStatusChangeObj.activityId == 600306) {
            this.activityService.recallOffer(this.candidateObj[0].applicationId).subscribe(
              (recall: any) => {
                const data = {
                  msg: recall.message,
                  isSuccess: recall.flag,
                };
                if (data.isSuccess == true) {
                  this.activityService.openSnackBar(data, 'success-snack');
                  this.statusChangeForRecall(obj);
                } else {
                  this.activityService.openSnackBar(data, 'danger-snack');
                }
              },
              (err) => {
                const data = {
                  msg: err,
                  isSuccess: false,
                };
                this.activityService.openSnackBar(data, 'danger-snack');
              },
            );
          }

          break;
      }

      if (this.checkStatusChangeObj.activityId != 600306) {
        this.activityService.saveStatusChangeActivity(obj).subscribe(
          (result1: any) => {
            console.log(result1);
            console.log('calling get statuschange activity check updated notes');
            if (result1.error && result1.error.toLowerCase() === 'failure') {
              const dataNew = {
                msg: result1.message,
                isSuccess: false,
              };

              console.log(dataNew);
              this.activityService.openSnackBar(dataNew, 'danger-snack');
            } else {
              this.value = true;
              //  this.refreshcandiates.emit("true");
              //this.getActivity();
              this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
              const data2 = {
                msg: result1.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(data2, 'success-snack');
              this.refreshcandiates.emit('true');
            }
          },
          (_err) => {
            const data3 = {
              msg: 'Some error occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data3, 'danger-snack');
          },
        );
      }
      //}
    }
  }

  editStatusChangeActivity(editObj: StatusChangeActivity) {
    console.log('inside edit');

    this.activityService.editStatusChangeActivity(editObj).subscribe(
      (res: any) => {
        console.log('response' + res);
        this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
        // this.getActivity();
        const data = {
          msg: 'Data Updated Successfully !!! ',
          isSuccess: true,
        };
        this.activityService.openSnackBar(data, 'success-snack');
        // this.activityService.openSnackBar('Data Updated Successfully !!! ', 'success-snack');
      },
      (err) => {
        const data = {
          msg: err,
          isSuccess: false,
        };
        this.activityService.openSnackBar(data, 'danger-snack');
      },
    );
    this.dialogRef.close();
  }

  getActivity(obj: CheckstatusChangeObj) {
    // obj.createdOn
    console.log('indide get activity function in component');
    console.log(obj);
    // this.ids = this.activityService.getDataIds();
    console.log(obj.applicationId);
    this.activityService
      .getStatusChangeActivity(obj.applicationId, obj.activityId, obj.processId, obj.createdOn)
      .subscribe((response: StatusChangeActivity) => {
        this.checkStatusChangeObj.statusChangeActivity = response;
        console.log('response from api-------', response);
        console.log('response ------->', response, typeof response, Array.isArray(response));
        console.log('modifiedOn --->', response.modifiedOn, typeof response.modifiedOn);
        this.dataInitialization(response);
      });
  }

  dataInitialization(statusChangeactivityObj: StatusChangeActivity) {
    if (statusChangeactivityObj == null) {
      this.notes = '';
      this.reasonid = 0;
      this.isDeleteDisable = true;
    } else {
      this.notes = statusChangeactivityObj.notes;
      // time
      this.timeModifiedOn = statusChangeactivityObj.modifiedOn;
      this.reasonId = statusChangeactivityObj.reason.reasonId.toString();

      this.isDeleteDisable = false;
    }
  }

  delete() {}

  receiveFileOutput(filedata) {
    this.fileData = filedata['fileMerge1'];
    this.deletedFile = filedata['deletedFile1'];
  }

  saveAttachment(genericId, companyHiringTypeId) {
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {},
        );
      });
    }
    const activityId: any = this.checkStatusChangeObj.activityId;
    const fd1 = new FormData();
    fd1.append('objectId', genericId);
    fd1.append('objectType', 'AP');
    fd1.append('attachmentId', '2');
    fd1.append('companyHiringTypeId', companyHiringTypeId);
    fd1.append('activityId', activityId);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fd1.append('file[' + file.name + ']', file);
      });
      this.fileService.upload(fd1).subscribe(
        (_res) => {},
        (_err) => {
          const data = {
            msg: 'Some error Occurred',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
        },
      );
    }
  }

  statusChangeForRecall(objs) {
    this.activityService.saveStatusChangeActivity(objs).subscribe(
      (resp: any) => {
        console.log(resp);
        console.log('calling get statuschange activity check updated notes');
        if (resp.error && resp.error.toLowerCase() === 'failure') {
          const data2 = {
            msg: resp.message,
            isSuccess: false,
          };

          this.activityService.openSnackBar(data2, 'danger-snack');
        } else {
          this.value = true;
          this.refreshcandiates.emit('true');
          //this.getActivity();
          this.saveAttachment(this.checkStatusChangeObj.applicationId, this.companyHiringType);
          const data4 = {
            msg: resp.message,
            isSuccess: true,
          };
          this.activityService.openSnackBar(data4, 'success-snack');
        }
      },
      (_err) => {
        const data6 = {
          msg: 'Some error occurred',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data6, 'danger-snack');
      },
    );
  }
}
